export default "__VITE_ASSET__02390bbf__"